<div *ngIf="!(onlyOneFile && files.length === 1)" class="dropzone" dropZone (hovered)="toggleHover($event)" (dropped)="selectedFile($event)" [class.hovering]="isHovering">

    <h3>{{ title }}</h3>
    <p>{{ subTitle }}</p>
    <div class="file  text-center">
        <label class="file-label" class="btn btn-primary">


      <input class="file-input" type="file" style="visibility: hidden; position: absolute" (change)="selectedFile($event.target.files)">

      <span class="file-cta">
        <span class="file-icon">
          <i class="fa fa-upload"></i>
        </span>
        <span class="file-label">
          {{ chooseText }}
        </span>
      </span>
    </label>
    </div>
</div>
<mat-list>
    <mat-list-item *ngFor="let f of files">
        <mat-icon mat-list-icon>insert_drive_file</mat-icon>
        <h4 mat-line>{{f.name}}</h4>

        <div *ngIf="f.percentage | async as pct">
            <div *ngIf="pct !== 100">
                <progress class="progress is-info" [value]="pct" max="100">
    </progress> {{ pct | number }}%
            </div>
        </div>
        <div *ngIf="(f.snapshot | async) as snap">

            <button mat-icon-button (click)="f.task.pause()" color="warning" class="button is-warning" *ngIf="isActive(snap)" [disabled]="!isActive(snap)"><mat-icon>pause_circle_filled</mat-icon></button>
            <button mat-icon-button (click)="f.task.cancel()" color="danger" class="button is-danger" *ngIf="isActive(snap)" [disabled]="!isActive(snap)"><mat-icon>cancel</mat-icon></button>
            <button mat-icon-button (click)="f.task.resume()" color="primary" class="button is-info" *ngIf="!(snap?.state === 'paused') && f.upload === false" [disabled]="!(snap?.state === 'paused')"><mat-icon>play_circle_filled</mat-icon></button>


        </div>
        <a mat-icon-button class="button is-info" class="button is-info" *ngIf="f.url" [href]="f.url" target="_blank" rel="noopener">
            <mat-icon>cloud_download</mat-icon>
        </a>
        <a mat-icon-button class="button is-danger" class="button is-danger" *ngIf="f.upload === true" (click)="deleteFile(f)">
            <mat-icon>delete</mat-icon>
        </a>
    </mat-list-item>
</mat-list>